import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { SeleccionService } from '../../servicios/seleccion.service';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { IngresoService } from '../../servicios/ingreso.service';
import { configuracion } from '../../recursos/config.service';

@Component({
  selector: 'app-educativa-reserva',
  templateUrl: './educativa-reserva.component.html',
  styleUrls: ['./educativa-reserva.component.css']
})
export class EducativaReservaComponent implements OnInit {


  public vecTurnos: Array<any>;
  public numTurno: string = '';
  public selectNumTurno: string; public resAtencion = '';
  public perIni: number = 0; public perFin: number = 0; private ban: boolean = false;

  public vecNumero = []; public vecDiasPermiso = [];
  public mr: NgbModalRef;
  public vecMedicos = []; public vecDatosCita = [];
  public encabezado: string = ""; public nombreBeca: string = ""; public buscar: string = ''; public opcReserva: boolean = true;
  constructor(private modalService: NgbModal, private alerti: AlertifyService, private srvSelect: SeleccionService, private cargando: LoaderComponent,
    private srvInsert: IngresoService, private confMensaje: configuracion) { }

  async ngOnInit() {
    this.encabezado = "Pisicología educativa";
    this.nombreBeca = localStorage.getItem('modNom');
    this.verTodosUsuarios();
    //this.buscar = localStorage.getItem('buscarConsulta');
    this.buscar = ''
    //await this.buscarEstudiante(2);
    this.instaciaPaciente();
  }
  //FUNCION PARA ABRIR EL MODAL QUE PERMITE BUSCAR UN ESTUDIANTE
  modBuscarEstudiante(nameMod) {
    if (localStorage.getItem('modUser') == 'true') {
      this.mr = this.modalService.open(nameMod);
      this.opcReserva = true;
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //BUSCAMOS LA MATRICULA DEL ESTUDIANTE
  async buscarEstudiante(op) {
    let cont = 0; let ban = false; this.opcReserva = true;
    this.instaciaPaciente();

    this.cargando.abrir();
    if (op == 1)
      this.cerrarModal();
    else
      this.buscar = localStorage.getItem('buscarConsulta');

    if (this.buscar) {
      //VERIFICAMOS LAS INSCRIPCIONES DEL ESTUDIANTE
      const resInscripcion = await new Promise<any>(resolve => this.srvSelect.gestionMatricula(1, 'na', this.buscar, 'na', 'na').subscribe(translated => { resolve(translated) }));
      if (resInscripcion.success) {
        while ((cont < resInscripcion.matricula.length) && !ban) {
          //VERIFICAMOS SI TIENE MATRÍCULA VIGENTE EL ESTUDIANTE
          const resMatricula = await new Promise<any>(resolve =>
            this.srvSelect.gestionMatricula(3, resInscripcion.matricula[cont]['baseCarrera'], this.buscar, 'na', 'na').subscribe(translated => { resolve(translated) }));
          if (resMatricula.success) {
            ban = true;
            //VERIFICAMOS SI TIENE HCE VIGENTE
            const resHC = await new Promise<any>(resolve => this.srvSelect.medicoHistoriaClinica(this.buscar).subscribe(translated => {
              resolve(translated)
            }));
            if (resHC.success) {
              this.vecDatosCita[0]['hce'] = resHC.roles[0]['NUM_CLINICA'];
              this.vecDatosCita[0]['tipoPaciente'] = 'ESTUDIANTE';
              this.vecDatosCita[0]['cargo'] = resInscripcion.matricula[0]['nombFacultad'];
              this.vecDatosCita[0]['dependencia'] = resInscripcion.matricula[0]['nombCarrera'];
              this.obtenerDatosCentralizada(this.buscar);
            }
            else {
              this.alerti.warning('El estudiante no dispone de historia clínica');
              this.opcReserva = true;
              this.vecDatosCita = [];
            }
          }
          cont++;
        }
      }
      else
        this.alerti.error('El usuario no cuenta con matrícula');
    }
    else
      this.alerti.error('Debe ingresar el número de cédula del estudiante.');
    this.cargando.cerrar();
  }
  //OBTENER LOS DATOS DEL ESTUDIANTE DE LA CENTRALIZADA
  async obtenerDatosCentralizada(dataBuscar) {
    const resCentral = await new Promise<any>(resolve => this.srvSelect.personaCentralDocumento(dataBuscar).subscribe(translated => {
      resolve(translated)
    }));
    if (resCentral.success) {
      this.vecDatosCita[0]['paciente'] = resCentral.datos['per_nombres'] + ' ' + resCentral.datos['per_primerApellido'] + ' ' + resCentral.datos['per_segundoApellido'];
      this.vecDatosCita[0]['email'] = resCentral.datos['per_email']; this.opcReserva = false;
    }
    else
      this.alerti.error('No se encontró al estudiante');
  }
  //INSTANCIAR EL VECTOR QUE CONTIENE LA INFORMACION DE LA RESERVA DE CITA
  instaciaPaciente() {
    this.vecDatosCita = [];
    this.vecDatosCita.push({
      hce: '', paciente: '', email: '', fecha: '', idTurno: '', hora: '', medico: '', horario: '', tipoReserva: '', tipoPaciente: '',
      cargo: '', dependencia: ''
    });
  }

  //FUNCIÓN QUE COJE UN MÉDICO SELECCIONADO Y CALCULA LOS TURNOS DE ATENCION
  async cambiaMedico() {
    let vecAuxMedico = this.vecMedicos.filter(item => item.Username == this.vecDatosCita[0]['medico']);
    let vecAuxHorario = []; let vecAuxTurnos = []; let vecCitaMedico = []; let vecRestringeMedico = []; let resAutoriza: boolean = false;
    let banNumTurnos: boolean = false;
    //VERIFICAMOS SI TIENE ALGUNA RESTRIGCION CON CITAS RESERVADAS EN LA MISMA FECHA
    const resReserva = await new Promise<any>(resolve =>
      this.srvSelect.medicoExisteCita(1, this.vecDatosCita[0]['medico'], vecAuxMedico[0]['tipo'], this.vecDatosCita[0]['hce'], localStorage.getItem("fechaReserva"), 'na',
        'na').subscribe(translated => { resolve(translated) }));
    if (resReserva.success) {
      if (resReserva.reserva.length <= 1)
        banNumTurnos = true;
      else
        banNumTurnos = false;
    }
    else
      banNumTurnos = true;
    if (banNumTurnos) {
      //OBTENER LOS HORARIOS DE ATENCION DEL PROFESIONAL DE LA SALUD
      const resHorario = await new Promise<any>(resolve =>
        this.srvSelect.medicoExisteCita(4, this.vecDatosCita[0]['medico'], vecAuxMedico[0]['tipo'], this.vecDatosCita[0]['hce'], localStorage.getItem("fechaReserva"), 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resHorario.success) {
        resAutoriza = resHorario.reserva[0]['citaUsuario'];// : resHorario.reserva[0]['citaPaciente'];
        if (resAutoriza) {
          /////////////////////////////OBTENER LAS CITAS RESERVADAS PARA LA FECHA DEL MEDICO
          const resCitas = await new Promise<any>(resolve => this.srvSelect.medicoExisteCita(6, this.vecDatosCita[0]['medico'], localStorage.getItem("fechaReserva"), 'na', 'na', 'na', 'na').subscribe(translated => {
            resolve(translated)
          }));
          vecCitaMedico = resCitas.success ? resCitas.reserva : [];
          /////////////////////////////VERIFICAR SI EL MEDICO TIENE PERMISO
          const resRestringe = await new Promise<any>(resolve =>
            this.srvSelect.medicoExisteCita(5, this.vecDatosCita[0]['medico'], localStorage.getItem("fechaReserva"), 'na', 'na', 'na', 'na').subscribe(translated => {
              resolve(translated)
            }));
          if (resRestringe.success) {
            for (let objRes of resRestringe.reserva) {
              vecRestringeMedico.push({
                horaI: objRes.FechaInicio.split('T')[1].split(':')[0], minI: objRes.FechaInicio.split('T')[1].split(':')[1].split(':')[0],
                horaF: objRes.FechaFin.split('T')[1].split(':')[0], minF: objRes.FechaFin.split('T')[1].split(':')[1].split(':')[0], id: objRes.id_horario
              });
            }
          }

          for (let objHorario of resHorario.reserva) {
            this.resAtencion = this.resAtencion + '  ' + objHorario.HORARIO;
            //DETERMINAR EL INTERVALO DE ATENCION EN BASE AL NUMERO DE TURNOS
            let horaInicio = objHorario.HORARIO.split('-')[0].split(':')[0]; let minuInicio = objHorario.HORARIO.split('-')[0].split(':')[1];
            let horaFin = objHorario.HORARIO.split('-')[1].split(':')[0]; let minuFin = objHorario.HORARIO.split('-')[1].split(':')[1];
            let intervalo = (parseInt(horaFin) - parseInt(horaInicio)) * 60;
            intervalo += parseInt(minuFin);
            intervalo -= parseInt(minuInicio);
            intervalo /= parseInt(objHorario.N_TURNO);
            //OBTENER DE MANERA INDIVIDUAL LOS HRARIOS DE CADA MEDICO
            vecAuxHorario.push({
              horaI: objHorario.HORARIO.split('-')[0].split(':')[0], minuI: objHorario.HORARIO.split('-')[0].split(':')[1],
              horaF: objHorario.HORARIO.split('-')[1].split(':')[0], minuF: objHorario.HORARIO.split('-')[1].split(':')[1],
              turnos: objHorario.N_TURNO, horario: objHorario.ID_HORARIO, intervalo: Math.trunc(intervalo), idHorario: objHorario.ID_HORARIO
            })
          }
          //CALCULO DE LOS TURNOS EN BASE AL HORARIO Y EL INTERVALO
          let minTurno: number = 0; let horaTurno: number = 0; let datoMenor = 1;
          for (let objTurno of vecAuxHorario) {
            horaTurno = parseInt(objTurno.horaI); minTurno = parseInt(objTurno.minuI);
            for (let cont = 1; cont <= objTurno.turnos; cont++) {
              datoMenor = 1
              //DAMOS EL FORMATO A LA HORA DEL TURNO
              let horCal = horaTurno < 10 ? '0' + horaTurno : horaTurno;
              let minCal = minTurno < 10 ? '0' + minTurno : minTurno;

              if (resHorario.reserva[0]['esFechaHoy'] == 1) {
                if (horaTurno <= resHorario.reserva[0]['fechaHoy'].split('T')[1].split(':')[0])
                  datoMenor = 0;
              }
              if (datoMenor == 1) {
                //VERIFICAMOS QUE EL MEDICO NO TENGA NO TENGA CITA RESERVADA PARA LADA FECHA Y HORA SELECCIONADA
                if (vecCitaMedico.filter(item => item.HORA.split('T')[1].split('.')[0] == horCal + ':' + minCal + ':00').length == 0) {
                  //CONTROLAMOS LAS RESTRIGCIONES DE TURNOS                                    
                  let banPer = 1;
                  for (let objPer of vecRestringeMedico) {
                    if (objPer.minI > 0 && objPer.horaI == horaTurno) {
                      if (minCal < objPer.minI)
                        banPer *= 1;
                      else
                        banPer *= 0;
                    }
                    else {
                      if (objPer.minF > 0 && objPer.horaF == horaTurno) {
                        if (minCal > objPer.minF)
                          banPer *= 1;
                        else
                          banPer *= 0;
                      }
                      else {
                        if (objPer.horaI <= horaTurno && horaTurno < objPer.horaF)
                          banPer *= 0;
                        else
                          banPer *= 1;
                      }
                    }
                  }
                  if (banPer == 1)
                    vecAuxTurnos.push({ horario: horCal + ':' + minCal, numHorario: objTurno.idHorario, estado: 1 });
                }
              }
              //SUMAMOS EL INTERVALO A LOS TURNOS CALCULADOS
              minTurno = (minTurno + parseInt(objTurno.intervalo));
              if (minTurno > 59) {
                horaTurno++;
                minTurno -= 60;
              }
            }
          }
        }
        else
          this.alerti.error('Este rol no permite reservar citas con el médico seleccionado');
      }
      else
        this.alerti.error('El médico seleccionado no tiene disponibilidad de turnos para la fecha indicada');
    }
    else
      this.alerti.error('EL PACIENTE YA TIENE UNA CITA CON UN PROFESIONAL DE LA MISMA RAMA');
    this.vecNumero = vecAuxTurnos;
  }
  //FUNCION QUE VERIFICA SI EL PACIENTE TIENE OTRA CITA MEDICA EN LA HORA INDICADA
  reservaTurno() {
    var horaHoy = this.numTurno.split(':')[0];
    var minuHoy = this.numTurno.split(':')[1];
    var horaInicio, minutoInicio, horaFin, minutoFin;
    horaInicio = parseInt(minuHoy) - 15 < 0 ? parseInt(horaHoy) - 1 : horaHoy; minutoInicio = parseInt(minuHoy) - 15 < 0 ? (parseInt(minuHoy) - 15) + 60 : parseInt(minuHoy) - 15;
    horaFin = parseInt(minuHoy) + 15 >= 60 ? parseInt(horaHoy) + 1 : horaHoy; minutoFin = parseInt(minuHoy) + 15 >= 60 ? (parseInt(minuHoy) + 15) - 60 : parseInt(minuHoy) + 15;

    this.srvSelect.medicoExisteCitaFecha(this.vecDatosCita[0]['hce'], localStorage.getItem("fechaReserva") + " " + horaInicio + "_" + minutoInicio, localStorage.getItem("fechaReserva") + " " + horaFin + "_" + minutoFin).subscribe(res => {
      if (!res.success) {
        this.srvSelect.medicoTurnosMedicos(1, this.vecDatosCita[0]['medico'], 'na', 'na', 'na', 'na').subscribe(res => {
          if (res.resultado) {
            this.selectNumTurno = this.numTurno;
            this.vecDatosCita[0]['idTurno'] = this.vecNumero.filter(item => item.horario == this.numTurno).length > 0 ?
              this.vecNumero.filter(item => item.horario == this.numTurno)[0]['numHorario'] : res.turnos[0]['id_HORARIO']
            this.ban = true;
          }
        });
      }
      else {
        this.alerti.error("El paciente ya tiene una cita en la fecha y hora seleccionada");
        this.ban = false;
      }
    });
  }
  //RESERVAMOS LA CITA PARA EL ESTUDIANTE
  async reservaCita() {
    if (this.ban && this.vecDatosCita[0]['hce'] != '' && this.vecDatosCita[0]['hce'] != null) {
      const resTurno = await new Promise<any>(resolve =>
        this.srvSelect.medicoCitasMedicoFecha(this.vecDatosCita[0]['medico'], localStorage.getItem("fechaReserva"), this.selectNumTurno.replace(':', '_')).subscribe(translated => {
          resolve(translated)
        }));
      if (!resTurno.success) {
        this.srvInsert.medicoIngresoReservaCita(this.vecDatosCita[0]['hce'], localStorage.getItem("fechaReserva") + " " + this.selectNumTurno.replace(':', '_'),
          this.vecDatosCita[0]['medico'], this.vecDatosCita[0]['idTurno'], 'REF. MEDICA', this.vecDatosCita[0]['tipoPaciente'], this.vecDatosCita[0]['cargo'],
          this.vecDatosCita[0]['dependencia'], localStorage.getItem('ciUsuario'), 'PE').subscribe(res => {
            if (res.usuarios) {
              this.enviarCorreo(localStorage.getItem("fechaReserva"), this.selectNumTurno, this.vecDatosCita[0]['medico']);
              this.verTodosUsuarios();
              this.alerti.success('La cita ha sido reservada con éxito');

              this.srvInsert.ingresoGestionAuditoria(localStorage.getItem('userAudita'), localStorage.getItem('perfilAudita'), 'ingresoReservaCita()', 'Reserva de cita médica a un estudiante',
                3, ' Médico: ' + this.vecDatosCita[0]['medico'] + '; Estudiante: ' + this.vecDatosCita[0]['hce'] + '; nombres: ' + this.vecDatosCita[0]['paciente'] + '; horario: ' + this.selectNumTurno.replace(':', '_') + '; fecha: ' + localStorage.getItem("fechaReserva") + ';', 1).subscribe(res => { });
              this.instaciaPaciente(); this.ban = false;
            }
            else
              this.alerti.error("Error al procesar los datos. Póngase en contacto con el administrador");
          });
      }
      else
        this.alerti.error("La cita no puede ser resevada en la hora y fecha indicada");
    }
    else
      this.alerti.error("La cita no puede ser reservada revise que los campos sean los correctos");
  }
  //CARGAR TODOS LOS USUARIOS CON HORARIO DE ATENCIÓN
  verTodosUsuarios() {
    this.srvSelect.medicohorarriosMedicos(3, 2).subscribe(res => {
      if (res.success)
        this.vecMedicos = res.horarios;
    });
  }
  //FUNCION QUE PERMITE EL ENVÍO DE CORREOS
  async enviarCorreo(fecha, turno, idMedico) {
    let doctor = "";
    const resMedico = await new Promise<any>(resolve =>
      this.srvSelect.medicoverUnMedico(idMedico).subscribe(translated => {
        resolve(translated)
      }));
    if (resMedico.success)
      doctor = resMedico.medico[0]['completo'];
    let contenido = this.confMensaje.bodyMensaje(11, 'na', 'na', 'na', 'na', 'na') + this.vecDatosCita[0]['paciente'] + this.confMensaje.bodyMensaje(12, 'na', 'na', 'na', 'na', 'na') + fecha + " a las " + turno
      + " con " + doctor + this.confMensaje.bodyMensaje(13, 'na', 'na', 'na', 'na', 'na');
    this.srvInsert.envioMail("Reserva de cita médica", this.vecDatosCita[0]['email'], btoa(contenido)).subscribe(res => {
      if (res.correo)
        this.alerti.error("Error al enviar el correo electrónico");
    });
  }

  //MUESTRA LOS MENSAJES DE ERROR AL SELECCIONAR LAS FECHAS DE LA CITA MÉDICA
  verificaFecha() {
    if (localStorage.getItem("mensaje") != "") {
      this.alerti.error(localStorage.getItem("mensaje"));
      localStorage.setItem("mensaje", "");
    }
    //this.instaciaPaciente();
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
}
